var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStorygameEnding = function SvgIconStorygameEnding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8.625V19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.625m-18 0V5a2 2 0 0 1 2-2h5.875M3.5 8.625h3.375m14.625 0V5a2 2 0 0 0-2-2h-1.375M21.5 8.625h-7.875m-6.75 0L11.375 3m-4.5 5.625h6.75M11.375 3h6.75m-4.5 5.625L18.125 3",
    stroke: "#fff",
    strokeOpacity: "current",
    strokeWidth: 1.5
  })));
};
export default SvgIconStorygameEnding;